// libraries
import React from 'react'

export function UxArrowUp() {
    return (
        <svg width="34" height="46" viewBox="0 0 34 46" xmlns="http://www.w3.org/2000/svg"><path d="M17 46C16.2 46 15.5 45.3 15.5 44.5V5.19995L3.10005 17.7C2.50005 18.3 1.60005 18.3 1.00005 17.7C0.400049 17.1 0.400049 16.2 1.00005 15.6L16 0.599951C16.3 0.299951 16.7 0.199951 17.1 0.199951C17.5 0.199951 17.9001 0.399951 18.2001 0.599951L33.2001 15.6C33.8001 16.2 33.8001 17.1 33.2001 17.7C32.6001 18.3 31.7 18.3 31.1 17.7L18.5 5.19995V44.5C18.5 45.3 17.9 46 17 46Z"/></svg>
    )
}

export function UxArrowDown() {
    return (
        <svg width="34" height="46" viewBox="0 0 34 46" xmlns="http://www.w3.org/2000/svg"><path d="M17 46.0001C16.6 46.0001 16.2 45.9001 15.9 45.6001L0.899951 30.6001C0.299951 30.0001 0.299951 29.1001 0.899951 28.5001C1.49995 27.9001 2.39995 27.9001 2.99995 28.5001L15.5 41.0001V1.6001C15.5 0.800098 16.2 0.100098 17 0.100098C17.8 0.100098 18.5 0.800098 18.5 1.6001V40.9001L31 28.4001C31.6 27.8001 32.4999 27.8001 33.0999 28.4001C33.6999 29.0001 33.6999 29.9001 33.0999 30.5001L18.1 45.5001C17.8 45.9001 17.4 46.0001 17 46.0001Z"/></svg>
    )
}

export function UxArrowLeft() {
    return (
        <svg width="46" height="34" viewBox="0 0 46 34" xmlns="http://www.w3.org/2000/svg"><path d="M16.6 33.6C16.2 33.6 15.8 33.5001 15.5 33.2001L0.499976 18.2001C0.199976 17.9001 0.0999756 17.5 0.0999756 17.1C0.0999756 16.7 0.299976 16.3 0.499976 16L15.5 1.00005C16.1 0.400049 17 0.400049 17.6 1.00005C18.2 1.60005 18.2 2.50005 17.6 3.10005L5.19998 15.5H44.5C45.3 15.5 46 16.2 46 17C46 17.8 45.3 18.5 44.5 18.5H5.19998L17.7 31C18.3 31.6 18.3 32.5 17.7 33.1C17.4 33.4 17 33.6 16.6 33.6Z"/></svg>
    )
}

export function UxArrowRight() {
    return (
        <svg width='17' height='14' viewBox='0 0 17 14' xmlns='http://www.w3.org/2000/svg'><path d='M0.226562 6.10034H15.1516V7.90034H0.226562V6.10034Z M9.25131 0.102539L16.1491 7.00033L9.25131 13.8981L7.97852 12.6253L13.6035 7.00033L7.97852 1.37533L9.25131 0.102539Z' fill='currentColor'/></svg>
    )
}